import cx from 'classnames';
import dateFormat from 'dateformat';
import { map, get } from "lodash";
import { ReactElement, useMemo } from 'react';

import { Message, UserDetails } from "../index";

import styles from "./styles.module.scss";
import Tooltip from 'src/components/tooltip';
import { Image } from 'react-bootstrap';

interface RichMessageComponentProps {
  message: Message;
  user: UserDetails;
  isSender: boolean;
  showOnlineStatus: boolean;
}

export const parseMessageContent = (content: string) => {
  const mentionRegex = /([@/])\[([^:]+):([^:]+):([^\]]+)\]/g;

  const elements: ReactElement[] = [];
  let lastIndex = 0;
  let match;

  while ((match = mentionRegex.exec(content)) !== null) {
    // Add text before match
    if (match.index > lastIndex) {
      elements.push(<span key={`text-${lastIndex}`}>{content.slice(lastIndex, match.index)}</span>);
    }

    const [fullMatch, char, type, id, label] = match;

    // Convert back into styled UI element
    if (char === '@') {
      elements.push(
        <span key={`mention-${id}-${match.index}`} className={styles.mention}>
          {char}{label}
        </span>
      );
    } else if (char === '/') {
      elements.push(
        <span key={`command-${id}-${match.index}`} className={styles.mention}>
          {char}{label}
        </span>
      );
    }

    lastIndex = mentionRegex.lastIndex;
  }

  // Add remaining text
  if (lastIndex < content.length) {
    elements.push(<span key={`text-${lastIndex}`}>{content.slice(lastIndex)}</span>);
  }

  return elements;
};

function formatTime24(ts: number): string {
  return ts ? dateFormat(new Date(ts / 10000), "HH:MM") : "";
}

const RichMessageComponent: React.FC<RichMessageComponentProps> = ({ message, user, isSender, showOnlineStatus }) => {
  const getMessageSentTime = () => {
    let timestamp = +Date();
    const receivedTime = get(message, 'receivedTime', null);

    if (receivedTime) {
      timestamp = receivedTime;
    }

    const result = dateFormat(timestamp / 10000, 'mmm d, yy hh:MM TT');

    return result;
  }

  return (
    <div className={cx(styles.messageSectionContainer)}>
      {
        map(get(message, 'contents', []), ((content: string, index: number) => {
          return (
            <div
              className={cx(styles.chatBodyMessage, {
                [styles.chatBodyMessageRight]: isSender,
              })}
            >
              <div className={styles.chatBodyMessageInner}>
                <Tooltip content={<span>{get(user, 'name', '')}</span>} placement="top">
                  <div className={styles.chatBodyMessageAvatar}>
                    {get(user, 'profilePicture', '') ? (
                      <Image className={styles.chatUserIcon} src={get(user, 'profilePicture', '')} roundedCircle />
                    ) : (
                      get(user, 'name', '')
                    )}
                  </div>
                </Tooltip>
                <div
                  className={cx(styles.chatBodyMessageBubble, {
                    [styles.chatBodyMessageBubbleRight]: isSender,
                  })}
                >
                  <div className={styles.chatBodyMessageText}>{parseMessageContent(content)}</div>
                  {getMessageSentTime() ? (
                    <span className={styles.chatBodyMessageTime}>
                      {formatTime24(+getMessageSentTime())}
                    </span>
                  ) : null}
                </div>
              </div>
            </div>
          );
        }))
      }
    </div>
  )
}

export default RichMessageComponent;
